import type { RoomSnapshot, Seat, Team } from '@euchre/core';

export function seatName(room: RoomSnapshot, seat: Seat, youAsYou = true): string {
  if (youAsYou && room.you.seat === seat) return 'You';
  const o = room.seats[seat]?.occupant;
  if (!o) return `Seat ${seat + 1}`;
  return o.name;
}

export function teamName(room: RoomSnapshot, team: Team): string {
  const seats = ([0, 1, 2, 3] as Seat[]).filter((s) => s % 2 === team);
  const mine = room.you.seat !== null && room.you.seat % 2 === team;
  if (mine) {
    const partner = seats.find((s) => s !== room.you.seat)!;
    return `You & ${seatName(room, partner)}`;
  }
  return seats.map((s) => seatName(room, s)).join(' & ');
}

/** Rotate seats so the viewer sits at the bottom. 0 = bottom, 1 = left, 2 = top, 3 = right. */
export function position(room: RoomSnapshot, seat: Seat): 0 | 1 | 2 | 3 {
  const me = room.you.seat ?? 0;
  return (((seat - me) % 4) + 4) % 4 as 0 | 1 | 2 | 3;
}

export const POSITION_CLASS = ['south', 'west', 'north', 'east'] as const;
